import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTAnticoagulantAntiplateletForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('anticoagulantAntiplateletSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        if (identifier == 'aspirin' || identifier == 'clopidogrelOrTicagrelor' || identifier == 'warfarin' || identifier == 'revaroxabanOrDabigatran' || identifier == 'otherMedication' ) {
            return this.getValue('anticoagulantOrAntiplateletAgent') == true; 
        }

        return true;
    }

    getValueType(identifier) {
        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-AnticoagulantAntiplateletForm.js